import { render, staticRenderFns } from "./BeforeSurvey.vue?vue&type=template&id=1dd9bad6&scoped=true"
import script from "./BeforeSurvey.vue?vue&type=script&lang=js"
export * from "./BeforeSurvey.vue?vue&type=script&lang=js"
import style0 from "./BeforeSurvey.vue?vue&type=style&index=0&id=1dd9bad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd9bad6",
  null
  
)

export default component.exports